import { render, staticRenderFns } from "./r-dropdown.vue?vue&type=template&id=19f78050&scoped=true"
import script from "./r-dropdown.vue?vue&type=script&lang=js"
export * from "./r-dropdown.vue?vue&type=script&lang=js"
import style0 from "./r-dropdown.vue?vue&type=style&index=0&id=19f78050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f78050",
  null
  
)

export default component.exports